import React, {useContext} from 'react';
import isEmpty from "lodash/isEmpty";
import {PriceContainer, StrikeThroughPrice, TotalPriceValue} from "./Reservation.style";
import isNil from "lodash/isNil";
import Text from "../../../components/UI/Text/Text";
import {formatPrice, getCurrencyCode} from "../../../library/helpers/utils";
import {useTranslation} from "react-i18next";
import {PopeyeContext} from "../../../context/PopeyeProvider";

const Price = props => {
    const {
        price,
        marina_settings,
        pricing,
        promotions,
    } = props;

    const { t } = useTranslation();
    const {
        isPreSignatureStatus,
        isPopeyeMember
    } = useContext(PopeyeContext);

    const getFormattedPrice = value => {
        if (price) {
            return formatPrice(price, 'en', marina_settings.currency);
        } else if (value === null) {
            return getCurrencyCode(marina_settings.currency) + ' **';
        } else {
            return formatPrice(value, 'en', marina_settings.currency);
        }
    };

    const renderStrikeThroughPrice = () => {
        if (
            (!isPopeyeMember && !isPreSignatureStatus) ||
            isEmpty(pricing) ||
            isEmpty(pricing.popeye) ||
            !promotions.length
        )
            return;

        const {
            total_to_pay,
            total_before_discounts,
            total_custom_surcharges,
            total_discounts,
            tem_discount
        } = pricing;
        const temDiscount = tem_discount || 0;
        const postTEMPrice =
            total_before_discounts +
            total_custom_surcharges -
            total_discounts -
            temDiscount;
        const isTotalMoreOrEqualToPost = postTEMPrice <= total_to_pay;

        if (isTotalMoreOrEqualToPost) return;

        return (
            <StrikeThroughPrice>{getFormattedPrice(postTEMPrice)}</StrikeThroughPrice>
        );
    };

    return <PriceContainer withMargin={(isPopeyeMember || isPreSignatureStatus) && !isEmpty(pricing)}>
        {renderStrikeThroughPrice()}

        <div>
            <TotalPriceValue>
                {getFormattedPrice(
                    !isEmpty(pricing) && !isNil(pricing.total_to_pay)
                        ? pricing.total_to_pay
                        : null
                )}
            </TotalPriceValue>

            <Text
                className='total-price-label'
                as='span'
                content={` / ${t('RESERVATION_WIDGET_PRICE_CALC')}`}
                fontSize="15px"
                fontWeight="400"
            />
        </div>
        {!isEmpty(pricing) && !isNil(pricing.total_to_pay) && (
            <Text
                as='p'
                className='reservation_price_disclaimer'
                content={t('RESERVATION_PRICE_DISCLAIMER')}
                marginBottom={0}
                lineHeight="20px"
            />
        )}
    </PriceContainer>
}

export default Price;
